import deviceMenu from '@js/common/deviceMenu.js';
import { appendSVGBtn } from '@js/common/customFunctions.js';
deviceMenu();
/* Script on ready
------------------------------------------------------------------------------*/
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.btn-link, .btn-play').forEach(function(element) {

        if (element.classList.contains('btn-link')) {
            const iconWrap = element.querySelector('i');

            if (iconWrap) {
                appendSVGBtn(iconWrap, '#icon-arrow', '24', '15');
            }

        } else if (element.classList.contains('btn-play')) {
            appendSVGBtn(element, '#icon-play-btn', '10', '13');
        }

    });
});

/* Use jQuery code Start
------------------------------------------------------------------------------*/

(function($) {
// Write code here


    const header = $('.main-header');

    $(window).on('scroll', function(){

        if ($(window).scrollTop() > 50){
            header.addClass('is-sticky');
        } else {
            header.removeClass('is-sticky');
        }

    });

})(jQuery);

/* ------------------------------------------------------------------------------
Use jQuery code End */